import React, { useEffect, useState } from "react";
import DraggableButtons from "../draggableButtons/draggableButtons";
import { useLightTheme } from "../../hooks/useLightTheme";
import "./modulesConfigurator.scss";

const ModulesConfigurator = ({
  pagePreferences = [],
  pageName,
  buttonLabel,
  configuratorWidth = 350,
  updatePreferences
}) => {
  const [preferences, setPreferences] = useState(pagePreferences);
  const [showSettings, setShowSettings] = useState(false);
  const isLightTheme = useLightTheme();
  //TODO: This is a temporary implementation; remove it after the dark theme is updated.
  const resolvedConfiguratorWidth =
    typeof configuratorWidth === "object"
      ? isLightTheme
        ? configuratorWidth.light
        : configuratorWidth.dark
      : configuratorWidth;

  useEffect(() => {
    const globalOverlayDomEl = document.getElementById("globalOverlay");
    const configuratorDomEl = document.getElementById(`${pageName}Configurator`);

    globalOverlayDomEl.addEventListener("click", () => {
      setShowSettings(false);
      globalOverlayDomEl.classList.remove("active");

      if (configuratorDomEl) {
        configuratorDomEl.classList.remove("active");
      }
    });

    reorderDashboardPreferences(preferences);
  }, []);

  useEffect(() => {
    showModules();
  }, [preferences]);

  useEffect(() => {
    const comparedPreferences = preferences.map((pref) => {
      const matchingPayload = pagePreferences.find((item) => item.name === pref.name);
      if (matchingPayload && pref.displayName !== matchingPayload.displayName) {
        return { ...pref, displayName: matchingPayload.displayName };
      }
      return pref;
    });

    setPreferences(comparedPreferences);
  }, [pagePreferences]);

  const showModules = () => {
    preferences
      .filter((pref) => pref.active)
      .map((pref) => {
        const name = pref.name.replace(/\s/g, "").toLowerCase();
        const customModuleWrapperDomEl = document.getElementById(name + "ModuleWrapper");
        if (customModuleWrapperDomEl) {
          customModuleWrapperDomEl.classList.add("active");
        }
      });
  };

  const toggleSettings = () => {
    const globalOverlayDomEl = document.getElementById("globalOverlay");
    const configuratorDomEl = document.getElementById(`${pageName}Configurator`);

    if (showSettings) {
      setShowSettings(false);
      if (globalOverlayDomEl) {
        globalOverlayDomEl.classList.remove("active");
      }

      if (configuratorDomEl) {
        configuratorDomEl.classList.remove("active");
      }
    } else {
      setShowSettings(true);

      if (globalOverlayDomEl) {
        globalOverlayDomEl.classList.add("active");
      }

      if (configuratorDomEl) {
        configuratorDomEl.classList.add("active");
      }
    }
  };

  const onListChange = (newList, item) => {
    let newListFiltered = [];
    newList
      .filter((pref) => pref.active)
      .map((pref) => {
        newListFiltered.push(pref);
      });
    setPreferences(newList);
    if (!item || item.active) {
      updatePreferences(newListFiltered);
    }
    reorderDashboardPreferences(newList);
  };

  const reorderDashboardPreferences = (preferences) => {
    const parentElement = document.getElementById(`${pageName}ModulesWrapper`);
    // get our preferences elements in order that was returned
    const preferenceElements = preferences
      // .reverse() // for easy debugging
      .map((pref) => pref.name.replace(/\s/g, "").toLowerCase() + "ModuleWrapper")
      .map((id) => document.getElementById(id));

    // clear out the parent element
    parentElement.innerHTML = "";
    // re add the elements in the order that we want.
    preferenceElements.forEach((el) => {
      // In case this element doesn't exist in the dom, then don't append
      if (el) {
        parentElement.appendChild(el);
      }
    });
  };

  return (
    <div id="modules-configurator">
      <button onClick={toggleSettings} className="configurator-toggle">
        {`${buttonLabel} Settings`}
      </button>
      <div
        data-testid="configurator-container"
        className={`configurator-container ${showSettings ? "active" : ""}`}
        style={{ minWidth: `${resolvedConfiguratorWidth}px`, display: showSettings ? "" : "none" }}
      >
        <DraggableButtons
          onListChange={onListChange}
          list={preferences}
          onButtonChange={onListChange}
        >
          <h3>Customize your Modules</h3>
          <p className="instructions">
            Click on Module number to toggle display. Drag <span className="arrows">▲</span> or{" "}
            <span className="arrows">▼</span> to adjust position.
          </p>
        </DraggableButtons>
      </div>
    </div>
  );
};

export default ModulesConfigurator;
